module.exports = __webpack_public_path__ + "img/klarna.ff2cf259.png";